/*!
 A simple CRS that can be used for flat non-Earth maps like panoramas or game maps, with Y axis inverted.
 (c) 2014-2018 Andxor soluzioni informatiche <http://www.andxor.it/>
*/

import { Simple } from 'leaflet/src/geo/crs/CRS.Simple';
import { Point } from 'leaflet/src/geometry/Point';
import { LatLng } from 'leaflet/src/geo/LatLng';
import { Transformation } from 'leaflet/src/geometry/Transformation';
import * as Util from 'leaflet/src/core/Util';

export var SimpleY = Util.extend({}, Simple, {
    projection: {
        project: function (latlng) {
            return new Point(latlng.lng, -latlng.lat);
        },
        unproject: function (point) {
            return new LatLng(-point.y, point.x);
        }
    },
    transformation: new Transformation(1, 0, -1, 0)
});
